import { ProgressIndicator } from "@fluentui/react";
import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { localize } from "src/l10n";
import { updateRemotePost } from "src/social-feed";
import { SpintrTypes } from "src/typings";
import { ImageCore, Label, LocalizedString } from "src/ui";
import { decodeHtmlEntities, formatInteractiveText, uniqueId } from "src/utils";
import "./SocialImage.scss";
import api from "src/spintr/SpintrApi";
import TranslateButton from "src/ui/components/TranslateButton";
import VideoViewCount from "src/ui/components/VideoViewCount";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import VideoJSPlayer from "src/components/VideoJSPlayer/VideoJSPlayer";

interface ISocialImageProps {
    post: Spintr.ISocialImage;
    parentPost?: Spintr.ISocialPostBase;
    dispatch: any;
    allowEdit?: boolean;
    uberId?: number;
    onRotateDone?: (imageUrl: string) => void;
}

interface ISocialImageState {
    componentId: string;
    postText: string;
}

class SocialImage extends Component<ISocialImageProps, ISocialImageState> {

    constructor(props : ISocialImageProps) {
        super(props);

        this.state = {
            componentId: uniqueId("SocialImage"),
            postText: this.props.post.Text
        };
    }

    public componentDidMount(): void {
        // If this is a videopost in progress, we set an interval and update the post via redux
        if (this.videoIsUploading(this.props.post)) {
            const i = setInterval(() => {
                api.get(`/api/v1/status/${this.props.post.Id}`).then((response) => {
                    this.props.dispatch(updateRemotePost(response.data));
                    if (!this.videoIsUploading(response.data)) {
                        clearInterval(i);
                    }
                });
            }, 10000);
        }
    }

    videoIsUploading = (post) => {
        const isImage : boolean = (
            post.photos !== undefined &&
            post.photos.length > 0 &&
            !post.photos[0].videoThumbnailUrl
        );

        return !isImage && post.FileStatus >= 0 && post.FileStatus <= 2;
    }

    protected translate = (text: string): void => {
        this.setState({ postText: text })
    }

    public render() : ReactNode {

        const { post } = this.props

        const isImage : boolean = (
            post.photos !== undefined &&
            post.photos.length > 0 &&
            !post.photos[0].videoThumbnailUrl
        );
            
        const imageUrl : string = isImage
            ? post.photos[0].photoUrl
            : post.VideoThumbnail;


        return(
            <div className="SocialImage">
                <div className="image-stage">
                    <a 
                        className={isImage ? "image-link is-image" : "image-link"}>
                        {isImage &&
                            <div className="maximize-icon">
                                <Visage2Icon icon="maximize-3" color="white" />
                            </div>}
                        {isImage
                            ? this.renderImage()
                            : this.renderVideo()}
                    </a>
                </div>
                {!isImage && !!post.VideoUrl && <div className="videoViewCount">
                    <VideoViewCount id={post.Id} url={post.VideoUrl} />
                </div>}
            </div>   
        );
    }

    public renderImage() :ReactNode {
        return (
            <ImageCore
                imageId={this.props.post.photos[0].id}
                src={this.props.post.photos[0].photoUrl}
                alt={this.props.post.photos[0].description}
                post={this.props.post}
                parentPost={this.props.parentPost}
                samePostOnly={true}
                openPhotoBoxOnClick={true}
                allowEdit={this.props.allowEdit}
                uberId={this.props.uberId}
                onRotateDone={this.props.onRotateDone} />
        )
    }

    public renderVideo() : ReactNode {
        const { post } = this.props;

        const usesPhotos = !!post.photos;
        
        const thumbnail = usesPhotos
            ? post.photos[0].videoThumbnailUrl
            : post.VideoThumbnail;

        if (post.FileStatus !== 3) {
            return (
                <>
                    {post.FileStatus === SpintrTypes.FileStatus.Error ? (
                        <div className="status">
                            <Label as="span">{localize("FilmenKundeIntePubliceras")}</Label>
                        </div>
                    ) : (
                        <div className="ProgressIndicator">
                            <ProgressIndicator
                                label={localize("BearbetningPagar")}
                                description={post.MediaUploadProgress > 0 
                                    ? `${post.MediaUploadProgress}% ${localize("Bearbetad").toLowerCase()}` 
                                    : `${localize("BearbetningForbereds")}`}
                                percentComplete={post.MediaUploadProgress > 0 && post.MediaUploadProgress / 100}
                            />
                        </div>
                    )}
                </>
            );
        }


        return (<>
                <div className="azure-video-item ignore-custom-font">
                    <div className="video">
                        <VideoJSPlayer uberId={post.Id} videoUrl={post.VideoUrl} thumbnailUrl={thumbnail} fill />
                    </div>
                </div>
            </>
        );
    }
}

export default connect()(SocialImage);